import React, { Component } from 'react';
import PropTypes from 'prop-types';

const LEFT_PAGE = 'LEFT';
const RIGHT_PAGE = 'RIGHT';

const range = (from, to, step = 1) => {
  let i = from;
  const range = [];

  while (i <= to) {
    range.push(i);
    i += step;
  }

  return range;
};
let selectedPage = 0;
class Pagination extends Component {
  constructor(props) {
    super(props);
    const { totalRecords = null, pageLimit = 30, pageNeighbours = 0 } = props;

    this.pageLimit = typeof pageLimit === 'number' ? pageLimit : 30;
    this.totalRecords = typeof totalRecords === 'number' ? totalRecords : 0;

    this.pageNeighbours =
      typeof pageNeighbours === 'number'
        ? Math.max(0, Math.min(pageNeighbours, 2))
        : 0;
    this.totalPages = Math.ceil(this.totalRecords / this.pageLimit);
    this.state = { currentPage: 1, totalPages: this.totalPages };
  }
  componentWillMount() {
    selectedPage = 0;
  }
  componentDidMount() {
    // this.gotoPage(1);
  }
  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        totalPages: Math.ceil(this.props.totalRecords / this.pageLimit)
      });
    }
  }
  gotoPage = (page) => {
    const { onPageChanged = (f) => f } = this.props;
    const currentPage = Math.max(0, Math.min(page, this.state.totalPages));
    const paginationData = {
      currentPage,
      totalPages: this.state.totalPages,
      pageLimit: this.pageLimit,
      totalRecords: this.props.totalRecords
    };
    selectedPage = currentPage;
    this.setState({ currentPage }, () => onPageChanged(paginationData));
  };

  handleClick = (page, evt) => {
    evt.preventDefault();
    this.gotoPage(page - 1);
  };

  handleMoveLeft = (evt) => {
    evt.preventDefault();
    this.gotoPage(selectedPage - this.pageNeighbours * 2 - 1);
  };

  handleMoveRight = (evt) => {
    evt.preventDefault();
    this.gotoPage(selectedPage + this.pageNeighbours * 2 + 1 - 1);
  };

  fetchPageNumbers = () => {
    const totalPages = this.state.totalPages;
    const currentPage = selectedPage;
    const pageNeighbours = this.pageNeighbours;

    const totalNumbers = this.pageNeighbours * 2 + 3;
    const totalBlocks = totalNumbers + 2;
    if (totalPages > totalBlocks) {
      let pages = [];

      const leftBound = currentPage - pageNeighbours;
      const rightBound = currentPage + pageNeighbours;
      const beforeLastPage = totalPages - 1;

      const startPage = leftBound > 2 ? leftBound : 2;
      const endPage = rightBound < beforeLastPage ? rightBound : beforeLastPage;

      pages = range(startPage, endPage);

      const pagesCount = pages.length;
      const singleSpillOffset = totalNumbers - pagesCount - 1;

      const leftSpill = startPage > 2;
      const rightSpill = endPage < beforeLastPage;

      const leftSpillPage = LEFT_PAGE;
      const rightSpillPage = RIGHT_PAGE;

      if (leftSpill && !rightSpill) {
        const extraPages = range(startPage - singleSpillOffset, startPage - 1);
        pages = [leftSpillPage, ...extraPages, ...pages];
      } else if (!leftSpill && rightSpill) {
        const extraPages = range(endPage + 1, endPage + singleSpillOffset);
        pages = [...pages, ...extraPages, rightSpillPage];
      } else if (leftSpill && rightSpill) {
        pages = [leftSpillPage, ...pages, rightSpillPage];
      }

      return [1, ...pages, totalPages];
    }

    return range(1, totalPages);
  };

  render() {
    if (!this.totalRecords) return null;

    if (this.state.totalPages === 1) return null;

    const { currentPage } = this.state;
    const pages = this.fetchPageNumbers();
    const headerClass = ['total_pages', currentPage ? 'current_page' : '']
      .join(' ')
      .trim();

    return (
      <div className='pagination_outer'>
        <div className={headerClass}>
          <strong className='text-secondary'>{this.props.totalRecords}</strong>{' '}
          Total Records
        </div>
        <nav aria-label='Pagination' className='Pagination'>
          <ul className='pagination'>
            {pages.map((page, index) => {
              if (page === LEFT_PAGE)
                return (
                  <li key={index} className='page-item'>
                    <a
                      className='page-link prev'
                      href='#'
                      aria-label='Previous'
                      onClick={this.handleMoveLeft}
                    >
                      <span aria-hidden='true'>&laquo;</span>
                      <span className='sr-only'>Previous</span>
                    </a>
                  </li>
                );

              if (page === RIGHT_PAGE)
                return (
                  <li key={index} className='page-item'>
                    <a
                      className='page-link next'
                      href='#'
                      aria-label='Next'
                      onClick={this.handleMoveRight}
                    >
                      <span aria-hidden='true'>&raquo;</span>
                      <span className='sr-only'>Next</span>
                    </a>
                  </li>
                );

              return (
                <li
                  key={index}
                  className={`page-item${
                    this.props.currentPage + 1 === page ? ' active' : ''
                  }`}
                >
                  <a
                    className='page-link'
                    href='#'
                    onClick={(e) => this.handleClick(page, e)}
                  >
                    {page}
                  </a>
                </li>
              );
            })}
          </ul>
        </nav>
        {currentPage && (
          <div className='pages'>
            Page{' '}
            <strong className='font-weight-bold'>
              {this.props.currentPage + 1}
            </strong>{' '}
            / <span className='font-weight-bold'>{this.state.totalPages}</span>
          </div>
        )}
      </div>
    );
  }
}

Pagination.propTypes = {
  totalRecords: PropTypes.number.isRequired,
  pageLimit: PropTypes.number,
  pageNeighbours: PropTypes.number,
  onPageChanged: PropTypes.func
};

export default Pagination;
